(async () => {

  if (!customElements.get('hero-slider')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options

    class HeroSwiper extends HTMLElement {

      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper]');
        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          threshold: 10,
        };

        if(!this.swiperElement) { return; }

        // Check if we have extra options on the HTML
        if ("options" in this.swiperElement.dataset) {
          const jsonOptions = JSON.parse(this.swiperElement.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // Call swiper init
        this.swiper = new Swiper(this.swiperElement, this.swiperOptions);

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiper.update();

            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
          });

          // When on block select go to the slide in front-end
          window.addEventListener('shopify:block:select', (event) => {
            this.swiper.update();

            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
            this.handleSectionDesignMode(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiper.update();

            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
            this.handleSectionDesignMode(event);
          });

        }

      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleSectionDesignMode(event) {

        // Check if the slide index is set
        if (!("swiperSlideIndex" in event.target.dataset)) { return; }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if(this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        this.swiper.slideTo(swipeToSlideIndex, 1000);

      }
    }

    window.HeroSwiper = HeroSwiper;

    customElements.define('hero-slider', HeroSwiper);

  }

})();
